import { DATA_SOURCES_MAPPING } from './dataSources';
import type { IMetricCalcMode } from '@/pages/intelligence/types/common';

// 数据源key、指标key 连接符
export const DATA_SOURCE_METRIC_KEY_JOINER = '###';

// 指标
export const METRICS_MAPPING = {
  PCU: 'pcu',
  ACU: 'acu',
  MAU: 'mau',
  REVENUE: 'revenue',
  UNITS: 'units',
  ARPPU: 'arppu',
  AST: 'ast',
};
// steam charts数据源的pcu指标
const STEAM_CHARTS_PCU = DATA_SOURCES_MAPPING.STEAM_CHARTS + DATA_SOURCE_METRIC_KEY_JOINER + METRICS_MAPPING.PCU;
// steam charts数据源的acu指标
const STEAM_CHARTS_ACU = DATA_SOURCES_MAPPING.STEAM_CHARTS + DATA_SOURCE_METRIC_KEY_JOINER + METRICS_MAPPING.ACU;
// Newzoo数据源的mau指标
const NEWZOO_MAU = DATA_SOURCES_MAPPING.NEWZOO + DATA_SOURCE_METRIC_KEY_JOINER + METRICS_MAPPING.MAU;
// MScience数据源的revenue指标
const MSCIENCE_REVENUE = DATA_SOURCES_MAPPING.MSCIENCE + DATA_SOURCE_METRIC_KEY_JOINER + METRICS_MAPPING.REVENUE;
// MScience数据源的units指标
const MSCIENCE_UNITS = DATA_SOURCES_MAPPING.MSCIENCE + DATA_SOURCE_METRIC_KEY_JOINER + METRICS_MAPPING.UNITS;
// MScience数据源的arppu指标
export const MSCIENCE_ARPPU = DATA_SOURCES_MAPPING.MSCIENCE + DATA_SOURCE_METRIC_KEY_JOINER + METRICS_MAPPING.ARPPU;
// MScience数据源的ast指标
const MSCIENCE_AST = DATA_SOURCES_MAPPING.MSCIENCE + DATA_SOURCE_METRIC_KEY_JOINER + METRICS_MAPPING.AST;
// npd数据源的revenue指标
const NPD_REVENUE = DATA_SOURCES_MAPPING.NPD + DATA_SOURCE_METRIC_KEY_JOINER + METRICS_MAPPING.REVENUE;

// 只有global数据的指标
export const ALL_ONLY_GLOBAL_DATA_METRICS = [STEAM_CHARTS_PCU, STEAM_CHARTS_ACU, NPD_REVENUE];

// 只有月粒度数据的指标
export const ALL_ONLY_MONTHLY_DATA_METRICS = [NEWZOO_MAU, NPD_REVENUE];

// 全部指标，数据源、指标 通过指定连接符 拼接起来的
export const ALL_DATASOURCES_METRICS = [
  STEAM_CHARTS_PCU,
  STEAM_CHARTS_ACU,
  NEWZOO_MAU,
  MSCIENCE_REVENUE,
  MSCIENCE_UNITS,
  MSCIENCE_AST,
  MSCIENCE_ARPPU,
  NPD_REVENUE,
];

// 指标名称
export const METRICS_NAMES_MAPPING: {
  [key: string]: {
    [key: string]: string;
  };
} = {
  [DATA_SOURCES_MAPPING.STEAM_CHARTS]: {
    // PCU: 'dbi_metric_pcu',
    // ACU: 'dbi_metric_acu',
    PCU: 'dbi_compare_metric_pcu',
    ACU: 'dbi_compare_metric_acu',
  },
  [DATA_SOURCES_MAPPING.NEWZOO]: {
    MAU: 'dbi_metric_mau',
  },
  [DATA_SOURCES_MAPPING.MSCIENCE]: {
    REVENUE: 'dbi_metric_digitalRevenue',
    UNITS: 'dbi_metric_units',
    ARPPU: 'dbi_metric_digitalARPPU',
    AST: 'dbi_metric_ast',
  },
  [DATA_SOURCES_MAPPING.NPD]: {
    REVENUE: 'dbi_metric_physical_revenue',
  },
};

// 指标hover气泡内容
export const METRICS_NAMES_TOOLTIPS_MAPPING: {
  [key: string]: {
    [key: string]: string;
  };
} = {
  [DATA_SOURCES_MAPPING.STEAM_CHARTS]: {
    PCU: 'dbi_compare_metric_pcu_tips',
    ACU: 'dbi_compare_metric_acu_tips',
  },
};

// 指标名称，扁平结构key，数据源、指标 通过 特定连接符 拼接
export const FLATTEN_METRICS_NAMES_MAPPING: {
  [key: string]: string;
} = {
  [STEAM_CHARTS_PCU]: METRICS_NAMES_MAPPING[DATA_SOURCES_MAPPING.STEAM_CHARTS].PCU,
  [STEAM_CHARTS_ACU]: METRICS_NAMES_MAPPING[DATA_SOURCES_MAPPING.STEAM_CHARTS].ACU,
  [NEWZOO_MAU]: METRICS_NAMES_MAPPING[DATA_SOURCES_MAPPING.NEWZOO].MAU,
  [MSCIENCE_REVENUE]: METRICS_NAMES_MAPPING[DATA_SOURCES_MAPPING.MSCIENCE].REVENUE,
  [MSCIENCE_UNITS]: METRICS_NAMES_MAPPING[DATA_SOURCES_MAPPING.MSCIENCE].UNITS,
  [MSCIENCE_ARPPU]: METRICS_NAMES_MAPPING[DATA_SOURCES_MAPPING.MSCIENCE].ARPPU,
  [MSCIENCE_AST]: METRICS_NAMES_MAPPING[DATA_SOURCES_MAPPING.MSCIENCE].AST,
  [NPD_REVENUE]: METRICS_NAMES_MAPPING[DATA_SOURCES_MAPPING.NPD].REVENUE,
};

// 指标tooltip气泡内容，扁平结构key，数据源、指标 通过 特定连接符 拼接
export const FLATTEN_METRICS_NAMES_TOOLTIPS_MAPPING: {
  [key: string]: string;
} = {
  [STEAM_CHARTS_PCU]: METRICS_NAMES_TOOLTIPS_MAPPING[DATA_SOURCES_MAPPING.STEAM_CHARTS].PCU,
  [STEAM_CHARTS_ACU]: METRICS_NAMES_TOOLTIPS_MAPPING[DATA_SOURCES_MAPPING.STEAM_CHARTS].ACU,
};

// 指标数值计算方式
export const METRICS_MODES_MAPPING: {
  [key: string]: {
    [key: string]: IMetricCalcMode;
  };
} = {
  [DATA_SOURCES_MAPPING.STEAM_CHARTS]: {
    PCU: 'max',
    ACU: 'avg',
  },
  [DATA_SOURCES_MAPPING.NEWZOO]: {
    MAU: 'avg',
  },
  [DATA_SOURCES_MAPPING.MSCIENCE]: {
    REVENUE: 'sum',
    UNITS: 'sum',
    ARPPU: 'avg',
    AST: 'avg',
  },
  [DATA_SOURCES_MAPPING.NPD]: {
    REVENUE: 'sum',
  },
};

// 指标数值计算方式，扁平结构key，数据源、指标 通过 特定连接符 拼接
export const FLATTEN_METRICS_MODES_MAPPING: {
  [key: string]: string;
} = {
  [STEAM_CHARTS_PCU]: METRICS_MODES_MAPPING[DATA_SOURCES_MAPPING.STEAM_CHARTS].PCU,
  [STEAM_CHARTS_ACU]: METRICS_MODES_MAPPING[DATA_SOURCES_MAPPING.STEAM_CHARTS].ACU,
  [NEWZOO_MAU]: METRICS_MODES_MAPPING[DATA_SOURCES_MAPPING.NEWZOO].MAU,
  [MSCIENCE_REVENUE]: METRICS_MODES_MAPPING[DATA_SOURCES_MAPPING.MSCIENCE].REVENUE,
  [MSCIENCE_UNITS]: METRICS_MODES_MAPPING[DATA_SOURCES_MAPPING.MSCIENCE].UNITS,
  [MSCIENCE_ARPPU]: METRICS_MODES_MAPPING[DATA_SOURCES_MAPPING.MSCIENCE].ARPPU,
  [MSCIENCE_AST]: METRICS_MODES_MAPPING[DATA_SOURCES_MAPPING.MSCIENCE].AST,
  [NPD_REVENUE]: METRICS_MODES_MAPPING[DATA_SOURCES_MAPPING.NPD].REVENUE,
};

// 指标数值计算方式 的名称
export const METRICS_CALC_MODES_NAMES_MAPPING: {
  [key in IMetricCalcMode]: string;
} = {
  // 平均值
  avg: 'Avg',
  // 汇总值
  sum: 'Sum',
  // 最大值
  max: 'Max',
};
